"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceGraphService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var ExperienceGraphService = /** @class */ (function () {
    function ExperienceGraphService() {
    }
    /**
     * Get Adjacent Roles
     * Given a role (category) id, return adjacent roles (categories)
     * @param cid An id representing a category/role/specialization
     * @param next
     * @param limit
     * @returns QueryResponse_TalentSpecialization_ Success
     * @throws ApiError
     */
    ExperienceGraphService.getAdjacentRoles = function (cid, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/role-adjacency/{cid}',
            path: {
                'cid': cid,
            },
            query: {
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Builder Skills
     * Given a list of skill ids, return associated builder skills
     * based on statistical co-occurence
     * @param skillIds Skill ids
     * @param next
     * @param limit
     * @returns QueryResponse_InternalExperienceGraph_ Success
     * @throws ApiError
     */
    ExperienceGraphService.getBuilderSkills = function (skillIds, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/builder-skills',
            query: {
                'skill_ids': skillIds,
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Unprocessable Entity",
            },
        });
    };
    /**
     * Get Builder Role Skills
     * Given a list of role ids, return associated builder skills
     * based on statistical co-occurence
     * @param roleIds Role ids
     * @param next
     * @param limit
     * @returns QueryResponse_InternalExperienceGraph_ Success
     * @throws ApiError
     */
    ExperienceGraphService.getBuilderRoleSkills = function (roleIds, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/builder-role-skills',
            query: {
                'role_ids': roleIds,
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Teammate Specializations
     * Given a list of role ids, return associated teammate specializations
     * based on statistical co-occurence
     * @param roleIds Role ids
     * @param next
     * @param limit
     * @returns QueryResponse_InternalExperienceGraph_ Success
     * @throws ApiError
     */
    ExperienceGraphService.getTeammateSpecializations = function (roleIds, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/teammate-specializations',
            query: {
                'role_ids': roleIds,
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Teammate Specializations Predictions
     * Given a list of role categories ids, return associated teammate specializations
     * based on statistical co-occurence.
     * @param requestBody
     * @returns ExperienceGraphTeammateSpecializationsPredictionResponse Success
     * @throws ApiError
     */
    ExperienceGraphService.teammateSpecializationsPredictions = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/experience-graph/teammate-specializations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Builder Industries
     * Given the builder's jwt token, return the builder's industries:
     * - profile declared industries
     * - project declared industries
     * - inferred industries (based on companies worked and on project descriptions)
     *
     * More info can be found in this [notion doc](https://www.notion.so/ateams/Declared-Inferred-Industries-955ada823e9a4ce2ab8d793ec16f2374) # noqa
     * @returns BuilderIndustries Success
     * @throws ApiError
     */
    ExperienceGraphService.getBuilderIndustries = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/builder-industries',
        });
    };
    /**
     * Get Adjacent Roles With Api Key
     * Given a role (category) id, return adjacent roles (categories)
     * @param cid An id representing a category/role/specialization
     * @param next
     * @param limit
     * @returns QueryResponse_TalentSpecialization_ Success
     * @throws ApiError
     */
    ExperienceGraphService.getAdjacentRolesWithApiKey = function (cid, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/experience-graph/role-adjacency/agent/{cid}',
            path: {
                'cid': cid,
            },
            query: {
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Post External Industries To Talent Industries
     * Given a list of apollo or clearbit industries,
     * return associated talent industries
     * @param requestBody
     * @returns InternalTalentIndustry Success
     * @throws ApiError
     */
    ExperienceGraphService.postExternalIndustriesToTalentIndustries = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/experience-graph/external-industries-to-talent-industries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Talent Profile Experience Graph Predictions
     * @param requestBody
     * @returns ExperienceGraphTalentProfileResponse Success
     * @throws ApiError
     */
    ExperienceGraphService.getTalentProfileExperienceGraphPredictions = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/experience-graph/talent-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Talent Profile Experience Graph Batch Predictions
     * Given a list of talent categories and role categories ids, return associated
     * roles or skills based on statistical co-occurence for each user
     * @param requestBody
     * @returns ExperienceGraphBatchTalentProfileResponse Success
     * @throws ApiError
     */
    ExperienceGraphService.getTalentProfileExperienceGraphBatchPredictions = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/experience-graph/talent-profile/batch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    return ExperienceGraphService;
}());
exports.ExperienceGraphService = ExperienceGraphService;
//# sourceMappingURL=ExperienceGraphService.js.map